import { useQuery } from 'data-fetching-client';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import getAssociationLabel from 'automation-ui-associations/utils/getAssociationLabel';
import findAssociationDefinitionFromSpec from 'automation-ui-associations/utils/findAssociationDefinitionFromSpec';
import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmailActionExplainer({
  action,
  flowObjectTypeId
}) {
  const {
    contentId,
    recipients
  } = action.metadata;
  const {
    data: {
      objectTypeById: targetObjectTypeDefinition = null
    } = {}
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId: CRMObjectTypes.CONTACT_ID
    }
  });
  const associationDefinitionsQuery = useAssociationDefinitions([flowObjectTypeId]);
  const emailName = /*#__PURE__*/_jsx(EmailName, {
    id: contentId
  });
  const showContactAssociationLabels = !!recipients.size;
  if (flowObjectTypeId === CRMObjectTypes.CONTACT_ID && !showContactAssociationLabels) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.explainer.enrolledContact",
      options: {
        emailName
      }
    });
  } else {
    const associationLabels = /*#__PURE__*/_jsx(FormattedList, {
      children: recipients.map(recipient => {
        const associationSpec = recipient.get('associationSpec');
        const associationDefinition = findAssociationDefinitionFromSpec(associationSpec, associationDefinitionsQuery);
        const key = associationSpec.getFullAssociationTypeId();
        return targetObjectTypeDefinition ? /*#__PURE__*/_jsx("strong", {
          children: getAssociationLabel({
            associationDefinition,
            toObjectTypeDefinition: targetObjectTypeDefinition
          })
        }, key) : /*#__PURE__*/_jsx(SkeletonText, {}, key);
      }).toJS()
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.explainer.associatedContacts",
      options: {
        emailName,
        count: recipients.size,
        associationLabels
      }
    });
  }
}